// extracted by mini-css-extract-plugin
export var arrow = "_3f-6";
export var changeItem = "_3f-3";
export var changesHeader = "_3f-1";
export var changesList = "_3f-2";
export var container = "_3f-0";
export var pathLabel = "_3f-4";
export var value = "_3f-7";
export var valuesContainer = "_3f-5";